import React from 'react';
import PropTypes from 'prop-types';
import { isNumber } from 'lodash';

const TrainerNameRow = ({ profile: {
    styleName,
    trainerLocation,
    runningToForm,
} }) => (
    <div className="mp-nameRow mp-nameRow_trainer">
        <div className="mp-nameRow__nameBlock">
            <h1 className="mp-nameRow__name">{ styleName }</h1>
            <span className="mp-nameRow__location">{ trainerLocation }</span>
        </div>
        { isNumber(runningToForm) &&
            <div className="mp-nameRow__rtfBlock">
                <span className="mp-nameRow__rtfPercentage">RTF {Math.round(runningToForm)}%</span>
                <span className="mp-nameRow__rtfText">Horses running to</span>
                <span className="mp-nameRow__rtfText">form in last 14 days</span>
            </div>
        }
    </div>
);


TrainerNameRow.propTypes = {
    profile: PropTypes.shape({
        styleName: PropTypes.string.isRequired,
        trainerLocation: PropTypes.string.isRequired,
        runningToForm: PropTypes.number,
    }).isRequired,
};

export default TrainerNameRow;



// WEBPACK FOOTER //
// ./src/js/human/nameRow/TrainerNameRow.jsx